module.exports = __webpack_public_path__ + "img/img_sd_adress_us@3x.d72d8a78.png";